<template>
  <v-row no-gutters>
    <v-col v-if="params.context.parentComponent.permissions.view">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <a
            :href="params.data.attachment"
            target="_blank"
            style="text-decoration: none"
            v-if="params.context.parentComponent.permissions.view"
          >
            <SecondaryButton
              x-small
              btnClass="mr-2 rounded"
              icon="mdi-eye"
              iconClass=""
              v-on="on"
              v-bind="attrs"
            >
            </SecondaryButton>
          </a>
        </template>
        <span>View</span>
      </v-tooltip>
    </v-col>
    <!-- <v-col v-if="params.context.parentComponent.permissions.change">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <PrimaryButton
            @click="editItem"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-pencil"
            iconClass=""
          >
          </PrimaryButton>
        </template>
        <span>Edit</span>
      </v-tooltip>
    </v-col> -->
    <!-- <v-col>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <ErrorButton
            @click="deleteExpense"
            v-if="params.context.parentComponent.permissions.view"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-delete"
            iconClass=""
          >
          </ErrorButton>
        </template>
        <span>Documents</span>
      </v-tooltip>
    </v-col> -->
  </v-row>
</template>

<script>
export default {
  methods: {
    view() {
      this.params.context.parentComponent.getViewAttachment(
        this.params.data.id
      );
    },
    editItem() {
      this.params.context.parentComponent.getTripExpenseEdit(
        this.params.data.id
      );
    },
    // deleteExpense() {
    //   this.params.context.parentComponent.deleteExpense(this.params.data);
    // },
    deleteItem() {
      this.params.context.parentComponent.deleteTripExpenses(
        this.params.data.id
      );
    },
  },
};
</script>

<style  scoped>
.switch-font-size i {
  font-size: 29px !important;
}
.switch-font-size button {
  font-size: 29px !important;
}
</style>
